import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';

const messages = defineMessages({
  edit: { id: 'actions.edit', defaultMessage: 'Edit' },
});

const JobProfileDisplay = ({ jobProfile, toggleEdit }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="panel panel-no-background panel-no-shadow">
      <div className="panel-heading">
        <h1 data-t="name">
          <div className="p-grid">
            <div className="p-col-6">{jobProfile.name}</div>
            <div className="p-col-6 align-right">
              <Button
                type="button"
                className="p-button-secondary"
                icon="fa fa-pencil"
                onClick={toggleEdit}
                tooltip={formatMessage(messages.edit)}
                tooltipOptions={{ position: 'bottom' }}
              />
            </div>
          </div>
        </h1>
      </div>

      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <FormattedMessage id="attrs.updated.verbose" defaultMessage="Updated at" />:
          <strong>
            <Gr8piFormattedDate dateValue={jobProfile.updatedOn} />
          </strong>
        </div>
        {jobProfile.internalDescription ? (
          <div className="p-col-12">
            <FormattedMessage id="attrs.internalDescription" defaultMessage="Internal description">
              {(text) => (
                <label className="field-label" htmlFor="job-detail-internal-desc">
                  {text}
                </label>
              )}
            </FormattedMessage>
            <InputTextarea id="job-detail-internal-desc" rows={6} disabled value={jobProfile.internalDescription} />
          </div>
        ) : (
          <div className="p-col-12">
            <FormattedMessage id="attrs.internalDescription.empty" defaultMessage="Empty description" tagName="p" />
          </div>
        )}
      </div>
    </div>
  );
};

JobProfileDisplay.propTypes = {
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default JobProfileDisplay;
